'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import {PersonFill} from "react-bootstrap-icons";

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import appStore from './AppStore';
import BannerMessages from "./BannerMessages";

const defaultHeaderLinks = [
    {url: 'https://myuw.washington.edu', text: 'MyUW'},
    {url: 'http://myplan.uw.edu/', text: 'MyPlan'}
]

/**
 * The header component.
 */
const AppHeaderDefault = ({links = defaultHeaderLinks, title, titleLink, enableBannerMessages = true}) => {
    const logout = async function () {
        if (appStore.isDevMode()) {
            console.log("Logout")
        }
        await appStore.getAnalyticsStore().flush();
        appStore.logout(() => appStore.redirect('https://idp.u.washington.edu/idp/profile/Logout'));
    }

    let navLinks;
    if (links.length > 0) {
        let navLinksList = links.map((link, index) => {
            return (
                <Nav.Link href={link.url} target="_blank" key={index}>{link.text}</Nav.Link>
            );
        });

        navLinks =
            <Nav aria-label="University of Washington">
                {navLinksList}
            </Nav>
    }


    let brandTitle = title ?? appStore.getAppContext();

    let navbarBrand;

    if (titleLink) {
        navbarBrand = <a href={titleLink} className="navbar-brand">{brandTitle}</a>
    } else {
        navbarBrand = <span className="navbar-brand">{title}</span>
    }

    let bannerMessages;
    if (enableBannerMessages) {
        bannerMessages = <BannerMessages/>
    }

    return (
        <header role="banner">
            {bannerMessages}
            <div className="bg-dark-purple">
                <Navbar className="container-xxl navbar-custom justify-content-between d-print-none">
                    {navLinks}
                    <Nav aria-label="Account Options">
                        <span aria-label="Logged in as" className="nav-text">
                            <PersonFill aria-hidden={true} />
                            <span className="ms-2 d-none d-md-inline">{appStore.getUserName()}</span>
                        </span>
                        <Nav.Link onClick={logout}>
                            Sign Out
                        </Nav.Link>
                    </Nav>
                </Navbar>
            </div>
            <div className="container-xxl app-header d-flex align-items-end">
                {navbarBrand}
            </div>
        </header>
    );
};

AppHeaderDefault.propTypes = {
    links: PropTypes.array,
    title: PropTypes.string,
    titleLink: PropTypes.string,
    enableBannerMessages: PropTypes.bool
}

export default AppHeaderDefault;
